import { shorthands, tokens, makeStyles } from '@fluentui/react-components';

export const previewStyles = makeStyles({
  previewContainer: {
    backgroundColor: 'inherit',
    ...shorthands.flex(1, 1, '1px'),
    minWidth: '1px',
    display: 'flex',
    flexDirection: 'column',
  },
  backButton: {
    justifySelf: 'start',
    ...shorthands.margin(tokens.spacingVerticalXXL, tokens.spacingHorizontalXXXL),
  },
  adPreviews: {
    ...shorthands.overflow('auto', 'auto'),
    paddingLeft: tokens.spacingHorizontalXXXL,
    paddingRight: tokens.spacingHorizontalXXXL,
    ...shorthands.flex(1, 1, '1px'),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalS,
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    columnGap: tokens.spacingHorizontalL,
    rowGap: tokens.spacingVerticalS,
  },
  centered: {
    display: 'flex',
    justifyContent: 'safe center',
    alignItems: 'safe center',
  },
  editButton: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    opacity: 0,
    lineHeight: tokens.lineHeightBase400,
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    minWidth: '96px',
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.borderWidth(tokens.strokeWidthThin),
    ...shorthands.borderColor(tokens.colorNeutralStroke1),
    ...shorthands.borderStyle('solid'),
    ...shorthands.padding('7px', tokens.spacingHorizontalL),
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  editIcon: {
    marginRight: tokens.spacingHorizontalSNudge,
    width: tokens.spacingHorizontalXXL,
    height: tokens.spacingVerticalXXL,
  },
  imageContainer: {
    position: 'relative',
    boxShadow: tokens.shadow2,
    '&:hover img, &:focus img': {
      filter: 'brightness(0.7)',
    },
    '&:hover .edit-button, &:focus .edit-button': {
      opacity: 1,
    },
    ...shorthands.transition('filter', '0.3s', 'ease-in-out'),
    ...shorthands.margin('1px'),
  },
  sizeText: {
    ...shorthands.padding(tokens.spacingVerticalNone, tokens.spacingHorizontalNone, tokens.spacingVerticalXS),
  },
});
